module.exports = __webpack_public_path__ + "static/media/ic_pdf.d6b6f3d0.svg";